import {ONE_DAY_MS} from '@/shared/consts/time';

import {SIGN_UP_INFO} from '../serve/consts';
import {get, remove, set} from '../serve/localStorage';
import {SignUpInfo} from './types';

const KEEP_AVATAR_TO_STORAGE = 2 * ONE_DAY_MS;

function isStaleAvatar(createdAd: number) {
  return createdAd + KEEP_AVATAR_TO_STORAGE < Date.now();
}

export function getNotStaleAvatars() {
  const {avatars = []} = getSignUpInfo();
  return avatars.filter(({createdAt}) => !isStaleAvatar(createdAt));
}

export function getSignUpInfo() {
  return get<Partial<SignUpInfo>>(SIGN_UP_INFO) || {};
}

export function getSignUpInfoItem<K extends keyof SignUpInfo>(
  key: K
): SignUpInfo[K] | undefined {
  return getSignUpInfo()[key];
}

export function patchSignUpInfo(pathAccount: Partial<SignUpInfo>) {
  const account = getSignUpInfo();
  set(SIGN_UP_INFO, {
    ...account,
    ...pathAccount,
  });
}

export function clearSignUpInfo() {
  remove(SIGN_UP_INFO);
}
